/* eslint-disable @typescript-eslint/no-var-requires */
import React, { useEffect, useRef } from 'react';
import { usePlayFlag } from './../../components/topicScroll';

import ImgPoint from '../../../../../assets/animation_point.gif';
import './animation019.less';

interface IAnimation019Item {
  content: string;
  subtitle: string;
}

interface IAnimation019Props {
  items: IAnimation019Item[];
  title?: string;
  onCompleted?: () => void;
}

const Animation019: React.FunctionComponent<IAnimation019Props> = ({
  items,
  title,
  onCompleted,
}) => {
  const [palySocialMedia, setPalySocialMedia] = React.useState(1);
  const crrRef = useRef() as React.MutableRefObject<HTMLDivElement>;
  const playFlag = usePlayFlag(crrRef.current as HTMLElement, '.course-body');
  const startPlay = (next = 1) => {
    setPalySocialMedia(next);
    next += 1;
    if (next <= items.length) {
      setTimeout(() => startPlay(next), 2700);
    } else {
      onCompleted && onCompleted();
    }
  };
  useEffect(() => {
    if (playFlag && palySocialMedia <= 1) {
      startPlay();
    }
  }, [playFlag]);

  const clickToPlay = () => {
    if (palySocialMedia <= 1) {
      startPlay();
    }
  };

  return (
    <div ref={crrRef} className="animation019" onClick={() => clickToPlay()}>
      <img
        className="click-point1"
        onClick={() => clickToPlay()}
        style={{
          display: palySocialMedia <= 1 ? 'block' : 'none',
        }}
        src={ImgPoint}
        alt=""
      />
      <div className="animation019-bg" />
      {title && (
        <div
          className="animation019-title"
          dangerouslySetInnerHTML={{ __html: title }}
        />
      )}
      {items.map((itm: IAnimation019Item, idx: number) => (
        <div
          key={idx}
          className={`animation019-panel s${idx + 1} animation  ${
            palySocialMedia >= idx + 1 ? 'fade-in' : ''
          }`}
        >
          <div className="animation019-container">
            <div
              className="animation019-subtitle"
              dangerouslySetInnerHTML={{ __html: itm.subtitle }}
            />
            <div
              className="animation019-content"
              dangerouslySetInnerHTML={{ __html: itm.content }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default Animation019;
